import { ParentProps } from 'solid-js'
import { Route, Router } from "@solidjs/router";
import styles from './sis-index.module.css'
import RoleDashboard from '../sis-role-dashboard/sis-role-dashboard';

export class IndexProps { }

export default function Index(props: ParentProps<IndexProps>) {
    const base = new URL(document.baseURI).pathname.replace(/\/$/, '');

    return (
        <Router base={`${base}/pages/sis`}>
            <Route path="/dashboard" component={RoleDashboard}></Route>
            <Route path="/" component={NoContent} />
        </Router>
    );
}

Index.defaultProps = new IndexProps();

function NoContent() {
    return <div>No Content</div>
}
